import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystacabinpune() {



const cardData =
{
  keyword: 'Innova Crysta Cab in Pune',

  heading: 'Lotus Cab: Innova Crysta Cab in Pune',

headingDescription:
    "Lotus Cabs offers premium Innova Crysta Cab in Pune for airport transfers, corporate travel, family vacations, wedding transportation, business meetings, sightseeing tours, outstation trips, pilgrimage journeys, and one-way or round-trip bookings. Our well-maintained Toyota Innova Crysta vehicles are spacious, comfortable, and ideal for small groups seeking a luxurious travel experience. Driven by professional and experienced chauffeurs, every journey is safe, punctual, and hassle-free. With 24x7 booking support, transparent pricing, doorstep pickup across Pune, and reliable customer service, Lotus Cabs ensures a comfortable and memorable ride for every occasion.",

  top: 'Top Places to Visit in Pune with Innova Crysta Cab',

  topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most frequently booked destinations for Innova Crysta cab travel from Pune. Whether you're traveling for business meetings, Mumbai Airport transfers, family visits, sightseeing, medical appointments, or weekend trips, the spacious comfort of an Innova Crysta makes the long-distance journey smooth, relaxing, and enjoyable for families and corporate travelers alike."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination visited by thousands of devotees from Pune every week. Travelers prefer booking an Innova Crysta for Sai Baba Darshan because of its spacious seating, premium comfort, and generous luggage space, making it ideal for families, senior citizens, and religious group tours."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station known for Venna Lake, strawberry farms, scenic viewpoints, and cool weather. The Innova Crysta offers excellent comfort on winding ghat roads, making it the preferred choice for family vacations, honeymoon trips, and weekend getaways from Pune."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the most popular weekend destinations near Pune, famous for Bhushi Dam, Tiger Point, Karla Caves, and lush green valleys. An Innova Crysta provides a comfortable and enjoyable journey for families and groups looking to explore this scenic hill station throughout the year."
    },
    {
        title: "Goa",
        description:
            "Goa is among the most popular long-distance routes from Pune for beach holidays, group vacations, and family trips. The spacious interiors, premium seating, powerful performance, and ample luggage capacity of the Innova Crysta make it an excellent vehicle for comfortable travel to North and South Goa."
    },
    {
        title: "Nashik",
        description:
            "Nashik is well known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and religious tourism. Travelers often hire an Innova Crysta from Pune for comfortable pilgrimage tours, wine tours, corporate travel, and family sightseeing while enjoying a smooth highway journey."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and rich Maratha heritage. The Innova Crysta is an ideal vehicle for families and pilgrimage groups traveling comfortably from Pune while carrying luggage and enjoying premium seating throughout the journey."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad, officially Chhatrapati Sambhajinagar, is home to the UNESCO-listed Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, and several historical monuments. An Innova Crysta offers the perfect combination of comfort and space for heritage tours and family vacations from Pune."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a favorite coastal destination known for beautiful beaches, sea forts, and peaceful resorts. Booking an Innova Crysta from Pune allows families and groups to travel comfortably with plenty of space for luggage, beach essentials, and sightseeing throughout the Konkan region."
    },
    {
        title: "Bhimashankar",
        description:
            "Bhimashankar Jyotirlinga is one of Maharashtra's most sacred pilgrimage destinations located in the Sahyadri Hills. The Innova Crysta is widely preferred for temple visits because of its smooth ride, comfortable cabin, and reliable performance on hilly roads, ensuring a pleasant pilgrimage experience for devotees traveling from Pune."
    }
],

  "services": [
    {
      "name": "Innova Crysta Cab in Pune",
      "description": "Book Innova Crysta cab in Pune for premium and spacious travel experience. Suitable for local city rides, corporate meetings, wedding events, and family trips. The SUV offers comfortable seating for up to 6-7 passengers with ample luggage space. Transparent per kilometer pricing ensures clear billing. Professional drivers provide punctual and safe service across Pune city."
    },
    {
      "name": "Innova Crysta Airport Cab Pune",
      "description": "Reliable Innova Crysta airport cab Pune service for timely pickup and drop at Pune Airport. Ideal for business executives and families requiring spacious and comfortable travel. Flight tracking support ensures punctual arrival."
    },
    {
      "name": "Innova Crysta Outstation Cab Pune",
      "description": "Premium Innova Crysta outstation cab from Pune to destinations like Mumbai, Nashik, Goa, Shirdi, and Kolhapur. Smooth suspension ensures relaxed long-distance highway travel."
    },
    {
      "name": "Innova Crysta Local Cab Pune",
      "description": "Local Innova Crysta cab service in Pune available for hourly rental, full-day booking, and city sightseeing. Ideal for corporate visits and family outings."
    },
    {
      "name": "Innova Crysta Corporate Cab Pune",
      "description": "Corporate Innova Crysta cab service offering professional chauffeur-driven transport for meetings, conferences, and airport transfers."
    },
    {
      "name": "Innova Crysta Wedding Cab Pune",
      "description": "Luxury Innova Crysta rental for wedding events and special occasions with well-maintained interiors and elegant appearance."
    },
    {
      "name": "Innova Crysta Family Cab Pune",
      "description": "Spacious SUV suitable for family trips, ensuring comfortable long-distance and local travel with adequate luggage space."
    },
    {
      "name": "Innova Crysta Cab in Hinjewadi & Wakad",
      "description": "Area-specific Innova Crysta cab service in Hinjewadi, Wakad, Baner, Hadapsar, Kharadi, and Pimpri Chinchwad for easy pickup and drop."
    }
  ],

  "tableData": [
    ["Innova Crysta Cab in Pune", "Innova Crysta Airport Cab Pune"],
    ["Innova Crysta Outstation Cab Pune", "Innova Crysta Local Cab Pune"],
    ["Innova Crysta Corporate Cab Pune", "Innova Crysta Wedding Cab Pune"],
    ["Innova Crysta Family Cab Pune", "Innova Crysta Cab in Hinjewadi & Wakad"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Premium SUV Comfort",
      "WhyChoosedescription": "Innova Crysta offers spacious seating and superior ride quality for comfortable travel."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs",
      "WhyChoosedescription": "Experienced drivers ensure punctual and safe city and highway travel."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure without hidden charges."
    },
    {
      "WhyChooseheading": "Local & Outstation Availability",
      "WhyChoosedescription": "Available for city rides, airport transfers, and long-distance travel."
    },
    {
      "WhyChooseheading": "Airport Pickup Support",
      "WhyChoosedescription": "Timely Pune Airport pickup and drop services."
    },
    {
      "WhyChooseheading": "Corporate & Event Travel",
      "WhyChoosedescription": "Suitable for business meetings and wedding functions."
    },
    {
      "WhyChooseheading": "Area-Wise Pickup",
      "WhyChoosedescription": "Service available across Hinjewadi, Wakad, Baner, and PCMC."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance",
      "WhyChoosedescription": "Round-the-clock support for booking and fare inquiries."
    }
  ]
}








const faqData = [
  {
    question: 'Does Lotus Cab provide Innova Crysta cab service in Pune?',
    answer: 'Yes, Lotus Cab offers premium Innova Crysta cab service in Pune for local travel, airport transfers, and outstation trips with professional drivers and clean vehicles.',
  },
  {
    question: 'What is the seating capacity of Innova Crysta?',
    answer: 'Innova Crysta typically offers 6+1 and 7+1 seating configurations, making it ideal for families, corporate groups, and comfortable long-distance travel.',
  },
  {
    question: 'What are the charges for Innova Crysta cab in Pune?',
    answer: 'Charges depend on trip type (local, airport, outstation), total distance, and duration. Lotus Cab provides transparent per km pricing with clear billing and no hidden charges.',
  },
  {
    question: 'Can I book Innova Crysta for Pune airport pickup and drop?',
    answer: 'Yes, Lotus Cab provides reliable Innova Crysta airport pickup and drop services in Pune with timely arrival and luggage assistance.',
  },
  {
    question: 'Is Innova Crysta suitable for outstation travel from Pune?',
    answer: 'Absolutely. Innova Crysta is perfect for long-distance travel from Pune due to its spacious interiors, comfortable seating, and smooth highway performance.',
  },
  {
    question: 'Does Lotus Cab offer Innova Crysta for corporate travel?',
    answer: 'Yes, we provide Innova Crysta for corporate meetings, business tours, and VIP transfers in Pune with professional and well-trained drivers.',
  },
  {
    question: 'Are toll and parking charges included in Innova Crysta fare?',
    answer: 'Toll, parking, and additional charges are billed separately as per actuals. Lotus Cab ensures complete transparency before booking confirmation.',
  },
  {
    question: 'Can I book Innova Crysta for multi-day trips?',
    answer: 'Yes, Lotus Cab offers flexible multi-day Innova Crysta packages for family vacations, pilgrimage tours, and corporate travel.',
  },
  {
    question: 'Is night travel available with Innova Crysta in Pune?',
    answer: 'Yes, Lotus Cab provides safe and secure night travel services with experienced drivers for both local and outstation trips.',
  },
  {
    question: 'How can I book Innova Crysta cab in Pune with Lotus Cab?',
    answer: 'You can book by sharing your travel details such as pickup location, date, duration, and passenger count to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Sharma',
    feedback: 'Booked Innova Crysta with Lotus Cab for Pune to Mumbai trip. The vehicle was spotless and very comfortable. Excellent service and smooth ride.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita Patil',
    feedback: 'Best Innova Crysta cab service in Pune. Spacious car, polite driver, and transparent pricing. Perfect for our family airport transfer.',
    rating: 5,
  },
];











































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Innova Crysta Cab in Pune",
"image": "https://lotuscab.com/assets/images/innova-crysta-cab-pune.jpg",
"description": "Book Innova Crysta Cab in Pune with Lotus Cab for premium, comfortable, and spacious travel. Ideal for airport transfers, outstation trips, weddings, and family travel with 7-seater AC luxury taxi service available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/innova-crysta-cab-pune"
}
};








  return (
    <div>
      


<Helmet>
  <title>Innova Crysta Cab in Pune | Luxury 7 Seater Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Innova Crysta Cab in Pune with Lotus Cab for premium travel. 7-seater luxury AC cab for airport transfers, outstation trips, weddings, and family travel. Affordable rates, professional drivers, and 24x7 service."
/>

<meta
 name="keywords"
 content="Innova Crysta Cab in Pune, Innova Crysta Pune Cab, Pune Innova Crysta Taxi, Crysta Cab Pune, Innova Cab Pune, 7 Seater Cab Pune, Luxury Cab Pune, Outstation Innova Crysta Pune, Airport Innova Cab Pune, Pune SUV Cab Innova, Pune Family Cab Service, Premium Cab Pune Innova Crysta, Hire Innova Crysta Pune, Toyota Innova Crysta Taxi Pune, Lotus Cab Pune Innova"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystacabinpune;